import theme from '@styles/theme';
export default {
  productCardInfoSwatches: {
    display: 'flex',
    flexDirection: 'row',
    mt: '12px',
    alignItems: 'flex-start',
    gap: '8px'
  },
  productCardInfoSwatch: (background?: string, color?: string) => {
    let swatchBackground = {};
    if (background) {
      swatchBackground = {
        background: `url(${background})`,
        backgroundPosition: 'center',
        backgroundSize: 'contain'
      };
    }
    if (color) {
      swatchBackground = {
        ...swatchBackground,
        backgroundColor: color
      };
    }
    return {
      borderRadius: '50%',
      border: `0.1px solid  ${theme.rawColors.lightGreyBorder}`,
      ...swatchBackground,
      display: 'inline-flex',
      flexShrink: 0,
      width: '16px',
      height: '16px'
    };
  },
  swatchLink: {
    display: 'inline-flex',
    flexShrink: 0,
    height: '16px',
    borderRadius: '50%',
    outline: 'none'
  },
  swatchWrapper: {
    display: 'inline-flex',
    flexShrink: 0,
    height: '16px'
  },
  remainingCount: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    flexShrink: 0,
    minWidth: '18px',
    height: '16px',
    fontSize: theme.fontSizes.smallText,
    lineHeight: 1,
    fontFamily: theme.fonts.uniformExtra,
    fontWeight: theme.fontWeights.normal,
    letterSpacing: '0.05em'
  }
};